/* @flow */

import SweetAlerts from 'sweetalert2';
import { BRAND_COLOR } from './utils/constants';

const swal = SweetAlerts.mixin({
    confirmButtonColor: BRAND_COLOR,
    cancelButtonText: 'Cancelar',
    reverseButtons: true,
});

export default swal;
